module.exports = "../img/ipad.png";